import { connect } from 'react-redux';

import Navigation from './Navigation';
import type { RootState } from 'services/store/types';

const mapStateToProps = (state: RootState) => ({
  auth: state.roles.status === 'SUCCEEDED',
  config: state.config,
});


export default connect(mapStateToProps)(Navigation);
